import { v4 as uuid } from 'uuid';

import { TMessageSchema, TMessageType, TReply } from '../../types/messages';

interface ICreateWsMessageParams {
  chatId: string;
  userId: number;
  type?: TMessageType;
  text?: string;
  payload?: string | null;
  uid?: string;
  read?: boolean;
  reply?: TReply | null;
}

/** Создаёт сообщение для отправки по сокету */
export function createWsMessage({
  text,
  chatId,
  userId,
  type = 'text',
  uid,
  read = false,
  reply,
}: ICreateWsMessageParams): TMessageSchema {
  const messageId = uid || uuid();

  return {
    created: new Date().toISOString(),
    text,
    userId,
    messageId,
    uid: messageId,
    chatId,
    status: read ? 'readByRecipient' : 'deliveredToServer',
    unread: !read,
    type,
    actionButtons: [],
    actionButtonsV3: [],
    offers: [],
    bubbles: [],
    rowVersion: 0,
    rowVersionV2: '',
    reply,
  };
}
